export { AlertsPage } from './alerts_page';
